const globalReducerInitialState = {
  amounts: {},
};

function globalReducer(state, action) {
  switch (action.type) {
    case 'SET_AMOUNT':
      return {
        ...state,
        amounts: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
}

export { globalReducerInitialState, globalReducer };
